import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryTabs() {
  const location = useLocation();
  const currentSlug = location.pathname.split('/category/')[1] || '';

  return (
    <div className="flex items-center gap-1.5 flex-wrap">
      <Link
        to="/"
        className={`px-4 py-2 rounded-full text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
          !currentSlug
            ? 'bg-primary-500 text-background-50 dark:text-foreground-950'
            : 'bg-background-100 text-foreground-600 hover:text-primary-500 hover:bg-primary-50'
        }`}
      >
        全部
      </Link>
      {categories.map((cat) => (
        <Link
          key={cat.id}
          to={`/category/${cat.slug}`}
          className={`px-4 py-2 rounded-full text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
            currentSlug === cat.slug
              ? 'bg-primary-500 text-background-50 dark:text-foreground-950'
              : 'bg-background-100 text-foreground-600 hover:text-primary-500 hover:bg-primary-50'
          }`}
        >
          {cat.name}
        </Link>
      ))}
    </div>
  );
}